<div class="container-fluid mt-3">
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>

    <div class="row justify-content-center p-3">
        <div class="col-12 my-1 border rounded-1 background-light w-100">
            <div class="row px-3">
                <mat-form-field class="col">
                    <mat-chip-grid #chipList aria-label="Analyste">
                        <mat-chip *ngFor="let u of model.AnalyserList" [selectable]="selectable" removable="true" (removed)="removeAnalyser(u)" [disabled]="model.Status === AnalyseStatut.Done">
                            {{u.Fullname}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input #analyste Input placeholder="Analystes..."
                               [matChipInputFor]="chipList"
                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                               [matAutocomplete]="auto"
                               [matChipInputAddOnBlur]="addOnBlur">
                    </mat-chip-grid>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedAnalyser($event)">
                        <mat-option *ngFor="let u of AllUserList" [value]="u">
                            {{u.Fullname}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col">
                    <mat-label>Date d'analyse</mat-label>
                    <input matInput placeholder="Date d'analyse" [matDatepicker]="picker" [(ngModel)]="model.Date" (focus)="picker.open()" [disabled]="model.Status === AnalyseStatut.Done">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                
                <mat-form-field class="col">
                    <mat-label>Durée d'analyse</mat-label>
                    <input matInput placeholder="Durée d'analyse" type="number" [(ngModel)]="model.Duration" [disabled]="model.Status === AnalyseStatut.Done">
                </mat-form-field>
            </div>

            <div class="row px-3">
                <mat-form-field class="col">
                    <mat-label>Facteur de concentration</mat-label>
                    <input matInput placeholder="Facteur de concentration" type="number" [(ngModel)]="model.AnalyseCyano.FacteurConcentration" [disabled]="model.Status === AnalyseStatut.Done">
                </mat-form-field>

                <mat-form-field class="col">
                    <mat-label>Volume de concentrat</mat-label>
                    <input matInput placeholder="Volume de concentrat (µL)" type="number" [(ngModel)]="model.AnalyseCyano.VolumeConcentrat" [disabled]="model.Status === AnalyseStatut.Done">
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-md-4 col-xl-2 my-3" *ngFor="let t of model.TaxonList">
            <div class="h-100 m-1">
                <div class="border rounded-1 background-light p-3 w-100 h-100 d-flex flex-column" >

                    <div class="row">
                        <h3 class="text-center" [matTooltip]="t.Comment" [matTooltipDisabled]="t.Comment !== undefined && t.Comment !== ''">
                            {{t.NomGenre}}
                            <!-- <div class="text-center"> </div> -->
                        </h3>
                    </div>

                    <div class="text-center"> Nombre de cellules {{t.Quantite}}</div>
                    <div class="text-center"> Colonie {{t.Colonie}}</div>

                    <div class="text-center fst-italic"> {{t.Comment}}</div>

                    <div class=" p-1 row d-flex justify-content-end mt-auto ">
                        <button appPreventDoubleClick class="col-auto me-auto" matTooltip="Ajouter une colonie" [throttleTime]="200" mat-icon-button color="accent" (throttledClick)="addColonie(t)" [disabled]="t.Colonie < 30 || !t.CanUndo || model.Status === AnalyseStatut.Done">
                            <mat-icon>add_circle</mat-icon>
                        </button>

                        <button appPreventDoubleClick class="col-auto"  [throttleTime]="200" mat-icon-button color="accent" (throttledClick)="undoLastCount(t)" [disabled]="!t.CanUndo || model.Status === AnalyseStatut.Done">
                            <mat-icon>undo</mat-icon>
                        </button>

                        <button appPreventDoubleClick class="col-auto" mat-icon-button color="primary" (throttledClick)="openCyanoTaxonDialog(t);" [disabled]="model.Status === AnalyseStatut.Done">
                            <mat-icon>edit</mat-icon>
                        </button>

                        <button appPreventDoubleClick class="col-auto" mat-icon-button color="warn" (throttledClick)="deleteTaxon(t);" [disabled]="model.Status === AnalyseStatut.Done">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>